import React, { useState, useEffect, useRef, useCallback } from 'react';
import "./BakerySearchAndAddProductStytles.scss"
import SearchGoods from "./ui/SearchGoods/SearchGoods";
import GoodItem from "./ui/GoodItem/GoodItem";
import { useSearchGoods } from "./lib/useSearchGoods";

const BakerySearchAndAddProduct = ({ onOpenAddProductModal }) => {
    // Теперь quantity доступно из хука
    const { search, loadMore, goods, loading, loadingMore, totalCount, hasMore, quantity } = useSearchGoods();
    const scrollContainerRef = useRef(null);
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    useEffect(() => {
        const fetchInitialGoods = async () => {
            setIsInitialLoad(true);
            await search('');
            setIsInitialLoad(false);
        };
        fetchInitialGoods();
    }, []);

    const handleSearchResults = async (results, searchText) => {
        await search(searchText);
    };

    const handleScroll = useCallback(() => {
        if (!scrollContainerRef.current) return;

        const { scrollTop, scrollHeight, clientHeight } = scrollContainerRef.current;
        const scrollPosition = scrollHeight - scrollTop - clientHeight;

        if (scrollPosition < 50 && !loadingMore && hasMore && !loading && goods.length > 0) {
            loadMore();
        }
    }, [loadingMore, hasMore, loadMore, loading, goods.length]);

    useEffect(() => {
        const container = scrollContainerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
            return () => {
                container.removeEventListener('scroll', handleScroll);
            };
        }
    }, [handleScroll]);

    const handleOpenProductModal = (good) => {
        if (onOpenAddProductModal) {
            onOpenAddProductModal(good);
        }
    };

    return (
        <div className="bakery-search-add">
            <SearchGoods onSearchResults={handleSearchResults} />

            <div className="bakery-search-add__results">
                <div className="bakery-search-add__title">
                    {`Товары ${quantity}`}
                </div>

                <div
                    className="bakery-search-add__grid-container"
                    ref={scrollContainerRef}
                >
                    <div className="bakery-search-add__grid">
                        {goods.map((good, index) => (
                            <GoodItem
                                key={good.id || index}
                                good={good}
                                onAddProduct={handleOpenProductModal}
                            />
                        ))}
                    </div>

                    {loadingMore && (
                        <div className="bakery-search-add__loading-more">
                            Загрузка еще товаров...
                        </div>
                    )}

                    {!hasMore && goods.length > 0 && (
                        <div className="bakery-search-add__end-message">
                            Все товары загружены ({totalCount} шт.)
                        </div>
                    )}

                    {(loading && goods.length === 0) && (
                        <div className="bakery-search-add__loading">Загрузка...</div>
                    )}

                    {!loading && !isInitialLoad && goods.length === 0 && (
                        <div className="bakery-search-add__empty">
                            Ничего не найдено
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BakerySearchAndAddProduct;